import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'formik';
import { Button } from 'primereact/button';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { LegacyInputTextComponent, FormikChips, FormikCheckbox } from '../../../components/prime-formik';
import { intlShape, formikFormShape } from '../../../components/prop-types';

const i18n = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  tag: { id: 'attrs.tags', defaultMessage: 'Tags' },
  save: { id: 'actions.save', defaultMessage: 'Save' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  commentEnabled: { id: '360.comments.enabled', defaultMessage: 'Comments allowed' },
});

const SurveyEditCoreForm = (props) => {
  const {
    onCancel,
    intl: { formatMessage },
    formProps: { isSubmitting, setFieldValue },
  } = props;

  const tagPlaceholder = formatMessage(i18n.tag);
  const commentEnabled = formatMessage(i18n.commentEnabled);
  return (
    <Form>
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <label className="field-label" htmlFor="name">
            <FormattedMessage id="360.name" defaultMessage="Survey name" />
          </label>
          <Field id="name" name="name" component={LegacyInputTextComponent} placeholder={formatMessage(i18n.name)} />
        </div>
        <div className="p-col-12">
          <label className="field-label" htmlFor="tags">
            <FormattedMessage id="360.tags" defaultMessage="Survey tags" />
          </label>
          <Field
            id="tags"
            name="tags"
            component={FormikChips}
            setFieldValue={setFieldValue}
            placeholder={tagPlaceholder}
            addOnBlur
          />
        </div>
        <div className="p-col-12">
          <Field
            id="commentsEnabled"
            name="commentsEnabled"
            component={FormikCheckbox}
            labelText={commentEnabled}
            setFieldValue={setFieldValue}
          />
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-12">
          <Button type="submit" label={formatMessage(i18n.save)} disabled={isSubmitting} />
          <Button type="button" className="p-button-secondary" label={formatMessage(i18n.cancel)} onClick={onCancel} />
        </div>
      </div>
    </Form>
  );
};

SurveyEditCoreForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  formProps: formikFormShape.isRequired,
};

export default injectIntl(SurveyEditCoreForm);
